/* Avalore Compact Keywords — crawlable link map (loaded on every page) */
window.AvaloreCompactKeywords = {
  brand: 'Avalore Jewelry',
  site: 'https://avalore-jewelry.co',
  pages: [
    { h: 'shop', t: 'Shop Jewelry by Style' },
    { h: 'vintage-pearl-earrings', t: 'Vintage pearl earrings' },
    { h: 'black-pearl-earrings', t: 'Black pearl earrings' },
    { h: 'waterproof-gold-bracelet', t: 'Waterproof gold bracelet' },
    { h: 'hypoallergenic-nickel-free-earrings', t: 'Hypoallergenic nickel free earrings' },
    { h: 'opal-dragonfly-necklace', t: 'Opal dragonfly necklace' },
    { h: 'emerald-pendant-necklace', t: 'Emerald pendant necklace' },
    { h: 'vintage-gold-hoop-earrings', t: 'Vintage gold hoop earrings' },
    { h: 'natural-pearl-necklace', t: 'Natural pearl necklace' },
    { h: 'gold-tennis-bracelet', t: 'Gold tennis bracelet' },
    { h: 'sapphire-cocktail-ring', t: 'Sapphire cocktail ring' },
    { h: 'elegant-pearl-drop-earrings', t: 'Elegant pearl drop earrings' },
    { h: 'waterproof-jewelry-for-women', t: 'Waterproof jewelry for women' },
    { h: 'gold-chain-necklace', t: 'Gold chain necklace' },
    { h: 'emerald-ring-gold', t: 'Emerald ring gold' },
    { h: 'vintage-nature-stone-earrings', t: 'Vintage nature stone earrings' },
    { h: 'ruby-heart-necklace', t: 'Ruby heart necklace' },
    { h: 'antique-dragonfly-earrings', t: 'Antique dragonfly earrings' },
    { h: 'cubic-zirconia-tennis-bracelet', t: 'Cubic zirconia tennis bracelet' },
    { h: 'pearl-stud-earrings', t: 'Pearl stud earrings' },
    { h: 'turquoise-stone-ring', t: 'Turquoise stone ring' },
    { h: 'amber-drop-earrings', t: 'Amber drop earrings' },
    { h: 'silver-heart-bracelet', t: 'Silver heart bracelet' },
    { h: 'gold-layered-necklace', t: 'Gold layered necklace' },
    { h: 'vintage-flower-ring', t: 'Vintage flower ring' },
    { h: 'crystal-hoop-earrings', t: 'Crystal hoop earrings' },
    { h: 'dainty-gold-necklace', t: 'Dainty gold necklace' },
    { h: 'butterfly-earrings', t: 'Butterfly earrings' },
    { h: 'moonstone-ring', t: 'Moonstone ring' },
    { h: 'garnet-drop-earrings', t: 'Garnet drop earrings' },
    { h: 'silver-hoop-earrings', t: 'Silver hoop earrings' }
  ],
  blogs: [
    { u: '/blogs/news/avalore-waterproof-jewelry-style-guide', t: 'Waterproof jewelry style guide' },
    { u: '/blogs/news/avalore-pearl-earrings-guide', t: 'Pearl earrings guide' },
    { u: '/blogs/news/avalore-waterproof-bracelets-guide', t: 'Waterproof bracelets guide' },
    { u: '/blogs/news/avalore-gemstone-jewelry-guide', t: 'Gemstone jewelry guide' }
  ]
};
